<div *ngIf="isLoaded"  class="card-container">

  <a class="header-back" [routerLink]="['/app']">
    <mat-icon inline=true fontSet="fa" fontIcon="fa-arrow-left" aria-label="back"></mat-icon>
    <span>My portfolios</span>
  </a> / {{portfolio.name}}
 

  <mat-toolbar>
    <h1>Risk analysis: {{optimName}}</h1>
  </mat-toolbar>

    <mat-card class="mb-3" id="risk-expected-risk" #expectedRiskReturnChart style="height: 300px !important;">
        <mat-card-header>
          <app-export-control
                  (exportClicked)="exportExpectedRiskReturnChart()"
                  [isExporting]="cardExporting['expectedRiskReturn']">
          </app-export-control>
          Expected Risk/Return <app-info infoIndex="25"></app-info>
        </mat-card-header>
        <mat-card-content>
            <div class="info-section">
                <div class="info-line">
                    <span class="info-title">Start Date</span>
                    <span class="info-value">{{ portfolio.start_date }}</span>
                </div>
                <div class="info-line">
                    <span class="info-title">End Date</span>
                    <span class="info-value">{{ portfolio.end_date }}</span>
                </div>
                <div class="info-line">
                    <span class="info-title">Number of Assets</span>
                    <span class="info-value">{{ riskContributionData ?  riskContributionData.length : "-"}}</span>
                </div>
                <div class="info-line">
                    <span class="info-title">Expected Return</span>
                    <span class="info-value" *ngIf="resultsTableDataFooter[0]"
                          style="text-transform: capitalize">{{resultsTableDataFooter[0].expectedReturn  }}</span>
                </div>
                <div class="info-line">
                    <span class="info-title">Expected Volatility</span>
                    <span class="info-value" *ngIf="resultsTableDataFooter[0]">{{ resultsTableDataFooter[0].volatility  }}</span>
                </div>
                <div class="info-line">
                    <span class="info-title">Expected Sharpe</span>
                    <span class="info-value" *ngIf="resultsTableDataFooter[0]">{{ resultsTableDataFooter[0].sharpe}}</span>
                </div>
                <div class="info-line">
                    <span class="info-title">VaR 95</span>
                    <span class="info-value"
                          style="text-transform: capitalize">{{ var95 * 100|number:'1.2-2' }}</span>
                </div>
                <div class="info-line">
                    <span class="info-title">VaR 99</span>
                    <span class="info-value">{{ var99 * 100|number:'1.2-2' }}</span>
                </div>

            </div>
        </mat-card-content>
    </mat-card>



    <mat-card class="mb-3" #riskReturnContributionChart>
        <mat-card-content>
          <app-export-control
                  (exportClicked)="exportRiskReturnContributionChart()"
                  [isExporting]="cardExporting['riskReturnContribution']">
          </app-export-control>
            <section id="risk-return-contribution">
                <div *ngIf="riskContributionData" >
                    <app-risk-contribution-column-chart
                            [riskContributionRaw]="riskContributionData"
                            [subHeader]="{portfolio: portfolio.name}">
                    </app-risk-contribution-column-chart>
                </div>
            </section>
        </mat-card-content>
    </mat-card>

    <mat-card #summaryMarginalRiskContributionChart>
      <mat-card-content>
        <app-export-control
                (exportClicked)="exportSummaryMarginalRiskContributionChart()"
                [isExporting]="cardExporting['summaryMarginalRiskContribution']">
        </app-export-control>
        <section id="summary-marginal-risk-contribution-chart">
          <div>
              <app-portfolio-return-bar-chart *ngIf="marginalRiskContributionData"
                                              [title]="'Marginal Risk Contribution'"
                                              [rawData]="marginalRiskContributionData">
              </app-portfolio-return-bar-chart>
          </div>
        </section>
      </mat-card-content>
    </mat-card>


    <mat-card class="mb-3" #covarianceMatrixTableDataChart>
          <mat-card-content>
            <app-export-control
                  (exportClicked)="exportCovarianceMatrixTableData()"
                  [isExporting]="cardExporting['covarianceMatrixTableData']">
            </app-export-control>
            <section id="covariance-matrix-table-data">
              <app-heatmap-table *ngIf="covarianceMatrixTableData" title="Covariance Matrix" [dataRaw]="covarianceMatrixTableData" [info]="27" [allowedTickers]="allowedTickers"></app-heatmap-table>
            </section>
          </mat-card-content>
        </mat-card>

      <mat-card class="mb-3" #correlationMatrixTableDataChart>
          <mat-card-content>
            <app-export-control
                  (exportClicked)="exportCorrelationMatrixTableData()"
                  [isExporting]="cardExporting['correlationMatrixTableData']">
            </app-export-control>
            <section id="correlation-matrix-table-data">
              
              <app-heatmap-table *ngIf="correlationMatrixTableData" title="Correlation Matrix" [dataRaw]="correlationMatrixTableData" [info]="28" [allowedTickers]="allowedTickers"></app-heatmap-table>
            </section>
          </mat-card-content>
        </mat-card>


      <mat-card class="mb-3" #hotSpotsChart>
          <mat-card-content>
            <app-export-control
                  (exportClicked)="exportHotSpotsChart()"
                  [isExporting]="cardExporting['hotSpots']">
            </app-export-control>
            <section id="hot-spots">
              <app-heatmap-chart title="Hot Spots" *ngIf="weightPieData.length > 0" [dataRaw]="weightPieData"></app-heatmap-chart>
            </section>
          </mat-card-content>
        </mat-card>


      <mat-card class="mb-3" #drawdownChart>
          <mat-card-content>
            <app-export-control
                  (exportClicked)="exportDrawdownChart()"
                  [isExporting]="cardExporting['drawdown']">
            </app-export-control>
            <section id="risk-drawdown">
             <app-line-chart title="Drawdown" [series]="comboData" [info]=31 [extraOptions]="comboExtraOptions"></app-line-chart>
            </section>
          </mat-card-content>
        </mat-card>

      <mat-card #volatilityChart>
          <mat-card-content>
            <app-export-control
                  (exportClicked)="exportVolatilityChart()"
                  [isExporting]="cardExporting['volatility']">
            </app-export-control>
            <section id="risk-volatility">
             <app-line-chart title="Volatility" [series]="volatilityData.series" [info]=32 [extraOptions]="drawDownExtraOptions"></app-line-chart>
            </section>
          </mat-card-content>
        </mat-card>

        <mat-card class="mb-4" #bestHedgeCard>
          <mat-card-content>
              <section id="best-hedge">
                  <app-best-hedge></app-best-hedge>
              </section>
          </mat-card-content>
      </mat-card>
  </div>